import { AppState as State } from '@ducks/index';
import {
  SearchParameter,
  MonthlyPlanSchedule,
  MonthlyPlanScheduleSummary,
  MonthlyTargetPlanSchedule,
} from './types';

/**
 * @summary リフレッシュを行うためのstateを返却する
 * @param {State} state
 * @returns {Record<string, never>}
 */
export const getRefreshId = (state: State) => state.plan.monthlySchedule.refresh;

/**
 * @summary ローディング状態かを返却する
 * @param {State} state
 * @returns {boolean} ローディング状態か
 */
export const checkIsLoading = (state: State) => state.plan.monthlySchedule.isLoading;

/**
 * @summary 月次スケジュールを個別取得中かを返却する
 * @param {State} state
 * @returns {boolean} 月次スケジュールを個別取得中か
 */
export const checkIsTargetPlanLoading = (state: State) =>
  state.plan.monthlySchedule.isTargetPlanLoading;

/**
 * @summary 送信処理中かを返却する
 * @param {State} state
 * @returns {boolean} 送信処理中か
 */
export const checkIsSubmitting = (state: State) => state.plan.monthlySchedule.isSubmitting;

/**
 * @summary ソート番号を返却する
 * @param {State} state
 * @returns {number}
 */
export const getSort: (state: State) => number = (state: State) => state.plan.monthlySchedule.sort;

/**
 * @summary 詳細検索条件を返却する
 * @param {State} state
 * @returns {SearchParameter}
 */
export const getSearchParameter: (state: State) => SearchParameter = (state: State) =>
  state.plan.monthlySchedule.searchParameter;

/**
 * @summary 月次計画リストを返却する
 * @param {State} state
 * @returns {MonthlyPlanSchedule[]}
 */
export const getPlans: (state: State) => MonthlyPlanSchedule[] = (state: State) =>
  state.plan.monthlySchedule.plans;

/**
 * @summary 月次計画サマリを返却する
 * @param {State} state
 * @returns {MonthlyPlanScheduleSummary|null}
 */
export const getSummary: (state: State) => MonthlyPlanScheduleSummary | null = (state: State) =>
  state.plan.monthlySchedule.summary;

/**
 * @summary 月次計画祝日リストを返却する
 * @param {State} state
 * @returns {number[]}
 */
export const getHolidays: (state: State) => number[] = (state: State) =>
  state.plan.monthlySchedule.holidays;

/**
 * @summary 月次個別計画を返却する
 * @param {State} state
 * @returns {MonthlyTargetPlanSchedule}
 */
export const getTargetPlan: (state: State) => MonthlyTargetPlanSchedule | null = (state: State) =>
  state.plan.monthlySchedule.targetPlan;

/**
 * @summary 選択を確定した契約を返却する
 * @param {State} state
 * @returns {{ id: number; name: string } | null}
 */
export const getContract: (state: State) => { id: number; name: string } | null = (state: State) =>
  state.plan.monthlyTable.contract;
